export const enum Environment {
	PRODUCTION = "production",
	DEVELOPMENT = "development",
}
